import React from "react";

const Solutions = ({ solutions }) => {
  return (
    <div className="flex flex-col items-start gap-3">
      <h2 className="text-[0.783rem] text-gray-800 leading-5 font-medium">
        Our Solution to solve company problems
      </h2>

      <div className="flex gap-5 flex-wrap">
        {solutions?.map((sol, i) => {
          return (
            <div
              key={i}
              className="bg-gray-50 px-3.5 py-1.5 rounded-md border border-gray-200"
            >
              <p className="text-[0.763rem] text-gray-700 leading-5 font-medium">
                {sol}{" "}
              </p>
              <p className="text-[0.683rem] text-gray-500 font-medium leading-[18px]">
                Service
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Solutions;
